export type ButtonIndex = 0 | 1 | 2 | -1 | -2;

export const BUTTON_LEFT = <ButtonIndex>0;
export const BUTTON_MIDDLE = <ButtonIndex>1;
export const BUTTON_RIGHT = <ButtonIndex>2;
export const BUTTON_ANY = <ButtonIndex>-2;
export const BUTTON_POINTERLOCK = <ButtonIndex>-1;
export const ANY = BUTTON_ANY;
export const POINTERLOCK = BUTTON_POINTERLOCK;
